var _path, _path2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5L6.5 7",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.5L6.5 9",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 8,
    r: 2.5,
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.5,
    r: 1.5,
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(1 0 0 -1 10.5 14)",
    stroke: "#ABB2B4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.fd915319b4f74d69a846335d4b0758a5.svg";
export { ForwardRef as ReactComponent };